import { Group, Select, Space } from "@mantine/core";
import { useState } from "react";
import ListaDeAutorizacaoDePerfil from "@/modules/acesso-pagina/components/lista-de-autorizacao-de-perfil";

const changeSelect = (setSelect: React.Dispatch<React.SetStateAction<string | null>>) => {
  return (value: string) => {
    setSelect(value);
  };
};

const AcessoPaginas = () => {
  const [select, setSelect] = useState(null);

  return (
    <>
      <Group justify={"end"}>
        <Select
          label="Acessos"
          placeholder="Perfil de acesso"
          data={data}
          onChange={changeSelect(setSelect)}
          value={select}
        />
      </Group>
      <Space h={"md"} />
      AA
      <ListaDeAutorizacaoDePerfil select={select} />
    </>
  );
};

export default AcessoPaginas;

const data = [
  { value: "1", label: "Administrador" },
  { value: "2", label: "Team" },
  { value: "3", label: "Master" },
  { value: "4", label: "Colaborador" }
];
